export default __webpack_public_path__ + "static/media/screen-desktop.c93d5e42.svg";